import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import { ContentTopBar } from 'components';
import { StyledContentBackground } from 'components/content-full-screen/content-full-screen';
import { RouteLeavingGuard } from 'components/route-leaving-guard/route-leaving-guard';
import {
  PasswordForm,
  PasswordFormValues,
  ProfileForm,
  ProfileFormValues,
} from 'features/account-settings';
import { useUpdateUser, useUserContext } from 'features/users';
import { omit } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const AccountSettingsView = () => {
  const [activeTab, setActiveTab] = useState('1');
  const { t } = useTranslation();
  const { user } = useUserContext();
  const [isProfileFormDirty, setIsProfileFormDirty] = useState(false);
  const [isPasswordFormDirty, setIsPasswordFormDirty] = useState(false);

  const { mutate: mutateUpdateUser, isLoading: isLoadingUpdateUser } =
    useUpdateUser();

 
  if (!user) return null;

  const onChange = (activeKey: string) => {
    setActiveTab(activeKey);
  };

  const handleUpdateProfile = (formData: ProfileFormValues) => {
    const payload = {
      ...omit(formData, ['phoneNumber','email','role']),
      userId: user.userId,
    };

    mutateUpdateUser(payload);
  };

  const handleUpdatePassword = (
    formData: PasswordFormValues,
    onSuccess: () => void,
  ) => {
    const payload = { ...formData, userId: user.userId };

    mutateUpdateUser(payload, { onSuccess });
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: `${t('accountSettings.tab.profile')}`,
      children: (
        <>
          <StyledContentBackground>
           
            <ProfileForm
              user={user}             
              handleSubmit={handleUpdateProfile}
              isLoading={isLoadingUpdateUser}
              setIsProfileFormDirty={setIsProfileFormDirty}
            />
          </StyledContentBackground>
        </>
      ),
    },
    {
      key: '2',
      label: `${t('accountSettings.tab.password')}`,
      children: (
        <StyledContentBackground>
          <PasswordForm
            handleSubmit={handleUpdatePassword}
            isLoading={isLoadingUpdateUser}
            setIsPasswordFormDirty={setIsPasswordFormDirty}
          />
        </StyledContentBackground>
      ),
    },
  ];

  return (
    <>
      <ContentTopBar title={t('accountSettings.title')} />
      <Tabs
        defaultActiveKey='1'
        activeKey={activeTab}
        items={items}
        onChange={onChange}
      />

      <RouteLeavingGuard blocked={isProfileFormDirty || isPasswordFormDirty} />
    </>
  );
};
